<template>
  <div class="app-container">
    <router-view></router-view>
    <bottom-nav v-if="showBottomNav" />
  </div>
</template>

<script>
import BottomNav from '@/components/bottom-nav/bottom-nav.vue'

const NAV_ROUTE_NAMES = ['Index', 'IndexWithMerchant', 'ProductList', 'OrderList', 'Profile']

export default {
  name: 'App',
  components: { BottomNav },
  computed: {
    showBottomNav() {
      return NAV_ROUTE_NAMES.includes(this.$route.name)
    }
  }
}
</script>

<style lang="scss">
@import './uni.scss';

.app-container {
  width: 100%;
  min-height: 100%;
}
</style>
